<template>
  <div class="status-select" v-on:click="openDropdown">
    <div class="status">
      <span :class="['circle', status.value]"></span>
      <span class="text">{{ status.label }}</span>
    </div>
    <div :class="['select', {open: isOpen}]">
      <div class="status" v-for="status in statuses" v-bind:key="status.value" v-on:click.stop="close(status)">
        <span :class="['circle', status.value]"></span>
        <span class="text">{{ status.label }}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "StatusSelect",
  data: function () {
    return {
      isOpen: false,
    };
  },
  props: ['statuses', 'status', 'id'],
  methods: {
    openDropdown: function () {
      this.isOpen = !this.isOpen;
    },
    close: function(status) {
      this.isOpen = false;
      // this.setStatus(status);
      this.$store.dispatch('waitlist/setStatus', { id: this.id, status: status });
    }
  },
}
</script>

<style lang="scss" scoped>
div.status-select {
  background-color: #F4F4F3;
  width: 100%;
  padding: 0.375rem 1rem 0.5rem;
  min-height: 40px;
  height: 100%;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  position: relative;
  cursor: pointer;

  &:after {
    content: "";
    width: 11px;
    height: 5px;
    position: absolute;
    top: calc(50%-2.5px);
    right: 1rem;
    background-image: url("data:image/svg+xml,%3Csvg width='11px' height='5px' viewBox='0 0 11 5' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3E%3Cg id='Page-1' stroke='none' stroke-width='1' fill='none' fill-rule='evenodd'%3E%3Cpolygon id='Triangle' fill='%23222222' transform='translate(5.500000, 2.500000) scale(1, -1) translate(-5.500000, -2.500000) ' points='5.5 0 11 5 0 5'%3E%3C/polygon%3E%3C/g%3E%3C/svg%3E");
  }

  span.text {
    text-transform: capitalize;
    font-size: 0.875rem;
    color: #4A4A4A;
    line-height: 1;
  }

  span.circle {
    display: block;
    width: 6px;
    height: 6px;
    border-radius: 50%;
    background-color: black;
    margin: 0 10px 0 0;

    &.contacted {
      background-color: #FFB22B;
    }

    &.in_progress {
      background-color: #45CB12;
    }

    &.no_contact {
      background-color: #9C9C9C;
    }
  }

  div.status {
    display: flex;
    justify-content: flex-start;
    align-items: center;
  }

  div.select {
    display: none;

    &.open {
      display: block;
      position: absolute;
      z-index: 5;
      top: 100%;
      left: 0;
      width: 100%;
      background-color: white;
    }

    > div.status {
      padding: 0.5rem 1rem 0.75rem;

      &:hover {
        background-color: #F4F4F3;
      }
    }
  }
}
</style>
